module.exports = (s) => {
  return [
    {
      name: '素材ID',
      format: ({ material }) => {
        return material.id;
      },
    },
    {
      name: '素材名称',
      format: ({ material }) => {
        return material.name;
      },
    },
    {
      name: '广告商',
      value: 'advertiser',
      format: ({ advertiser }) => {
        return s.channel_interface_map[advertiser];
      },
    },
    {
      name: '消耗',
      props: {
        sortable: 'custom',
      },
      value: 'cost',
    },
    {
      name: '激活数',
      props: {
        sortable: 'custom',
      },
      value: 'active',
    },
    {
      name: '激活成本',
      props: {
        sortable: 'custom',
      },
      value: 'active_cost',
    },
    {
      name: '注册数',
      props: {
        sortable: 'custom',
      },
      value: 'register',
    },
    {
      name: '注册成本',
      props: {
        sortable: 'custom',
      },
      value: 'register_cost',
    },
    {
      name: '付费数',
      props: {
        sortable: 'custom',
      },
      value: 'pay',
    },
    {
      name: '付费成本',
      props: {
        sortable: 'custom',
      },
      value: 'pay_cost',
    },
    {
      name: '付费金额',
      props: {
        sortable: 'custom',
      },
      value: 'pay_amount',
    },
    {
      name: '曝光数',
      props: {
        sortable: 'custom',
      },
      value: 'impression',
    },
    {
      name: '点击量',
      props: {
        sortable: 'custom',
      },
      value: 'click',
    },
    {
      name: '点击率',
      props: {
        sortable: 'custom',
      },
      value: 'click_rate',
    },
    {
      name: '小游戏付费金额',
      props: {
        sortable: 'custom',
      },
      value: 'mini_game_paying_amount',
      format: function({ mini_game_paying_amount }) {
        return mini_game_paying_amount || '不支持';
      },
    },
    {
      name: '小游戏首次付费人数',
      props: {
        sortable: 'custom',
      },
      value: 'mini_game_first_paying_users',
      format: function({ mini_game_first_paying_users }) {
        return mini_game_first_paying_users || '不支持';
      },
    },
    {
      name: '小游戏付费成本',
      props: {
        sortable: 'custom',
      },
      value: 'mini_game_first_paying_cost',
      format: function({ mini_game_first_paying_cost }) {
        return mini_game_first_paying_cost || '不支持';
      },
    },
    {
      name: '作者',
      format: ({ material }) => {
        return material?.author?.name || '-';
      },
    },
    {
      name: '需求人',
      format: ({ material }) => {
        return material?.demand_sider?.name || '-';
      },
    },
    {
      name: '缩略图',
      align: 'center',
      format: ({ material }) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('material-preview',
              {
                props: {
                  'materialType': material.material_type,
                  'material-list': material.url,
                },
              }, ''),
          ]);
        return ele;
      },
    },
  ];
};
